import 'core-js/stable';
import 'core-js/es/symbol/iterator';

import './index.css'

import React from 'react'
import * as ReactDOMClient from 'react-dom/client';
import { register as registerServiceWorker } from './serviceWorkerRegistration';
import { App } from './App'

const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);

root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>,
)

registerServiceWorker();
